<button
  class="flex items-center justify-center -my-3 py-3 h-18 px-4 text-white min-w-48 focus:bg-white focus:bg-opacity-10 hover:bg-white hover:bg-opacity-10"
  (click)="dropdownMenu.toggle($event)"
>
  <span class="font-bold bg-primary rounded-full size-10 text-xl mr-3 flex items-center justify-center">{{ currentUser?.initials }}</span>
  {{ currentUser?.name }}
</button>

<rkt-menu className="user-dropdown" #dropdownMenu [model]="dropdownMenuItems"></rkt-menu>
